module.exports = __webpack_public_path__ + "img/MZN.8200d96b.svg";